/**
 * Rafraîchit la majorité des données necessaires à l'appli
 * @type {string}
 */
export const REFRESH_DATA = 'refreshData'
